'use client';

import { useState } from 'react';
import Slider, { Settings } from 'react-slick';
import { FiChevronLeft, FiChevronRight } from 'react-icons/fi';
import './styles.css';
import TeamListItem from './TeamListItem';
import TeamListDialog from './TeamListDialog';

const settings: Settings = {
  dots: false,
  infinite: true,
  speed: 1000,
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  dotsClass: 'carousel-dots',
  responsive: [
    {
      breakpoint: 768,
      settings: {
        dots: true,
      },
    },
  ],
};

export type TeamMemberInfo = {
  name: string;
  position: string;
  srcSet: string;
  description: string;
};

type Props = {
  teamInfo: TeamMemberInfo[];
  showTranslation: string;
};

export default function TeamList({ teamInfo, showTranslation }: Props) {
  const [sliderRef, setSliderRef] = useState<Slider | null>(null);
  const [dialogIsOpen, setDialogIsOpen] = useState(false);
  const [selectedMemberIndex, setSelectedMemberIndex] = useState<number>();

  function handleOpenDialog(index: number) {
    setDialogIsOpen(true);
    setSelectedMemberIndex(index);
  }

  return (
    <div className="relative">
      {dialogIsOpen && (
        <TeamListDialog
          selectedMemberIndex={selectedMemberIndex}
          teamMembers={teamInfo}
          handleClose={() => setDialogIsOpen(false)}
        />
      )}
      <div className="hidden lg:flex flex-wrap mx-[-0.9375rem] text-center mt-[60px]">
        {teamInfo.map((member, index) => (
          <div
            className="w-[calc(33.33333%-1.875rem)] desktop:w-[calc(25%-1.875rem)] mx-[0.9375rem] flex-[0_0_auto]"
            key={index}>
            <TeamListItem
              member={member}
              handleClick={() => handleOpenDialog(index)}
              showTranslation={showTranslation}
            />
          </div>
        ))}
      </div>
      <button
        onClick={sliderRef?.slickPrev}
        className="w-11 h-[44px] bg-white rounded-full shadow-default absolute top-[calc(50%-40px)] mt-[60px] cursor-pointer translate-y-[-50%] outline-none z-10 lg:hidden">
        <FiChevronLeft className="w-6 h-6 text-gray-500 mx-auto" />
      </button>
      <button
        onClick={sliderRef?.slickNext}
        className="w-11 h-[44px] bg-white rounded-full shadow-default absolute top-[calc(50%-40px)] right-0 mt-[60px] cursor-pointer translate-y-[-50%] outline-none z-10 lg:hidden">
        <FiChevronRight className="w-6 h-6 text-gray-500 mx-auto" />
      </button>
      <Slider
        ref={setSliderRef}
        className="mt-[60px] mx-[-0.9375rem] text-center lg:!hidden"
        {...settings}>
        {teamInfo.map((member, index) => (
          <TeamListItem
            key={index}
            member={member}
            handleClick={() => handleOpenDialog(index)}
            showTranslation={showTranslation}
          />
        ))}
      </Slider>
    </div>
  );
}
